import React, { useEffect, useState } from "react";
import SideBar from "../components/sidebar";
import Dropdowns from "../components/dropdowns";
import { aiAnalysisTypes } from "../components/analysisTypes";
import { RaceAnalysis, LapAnalysis } from "../components/analysisTypes";

const Coach = ({
  showSidebar,
  setPage,
  page,
  dropdownStates,
  setDropdownStates,
  setFigureImage,
  raceResultLoaded,
  setRaceResultLoaded,
}) => {
  const [analysisType, setAnalysisType] = useState("");
  const [raceResult, setRaceResult] = useState([]);
  const [analysisComponent, setAnalysisComponent] = useState(null);
  const [doAllInputsExist, setDoAllInputsExist] = useState(false);
  const [promptInputError, setPromptInputError] = useState(false);
  const [round, setRound] = useState(null);
  const [chatGPTResponse, setChatGPTResponse] = useState("");

  // UseEffect to fetch round then race result sequentially when dropdowns change
  useEffect(() => {
    if (!dropdownStates) return;
    const year = dropdownStates[0];
    const trackID = dropdownStates[1];

    setRaceResult([]);

    // Get the round number, then fetch result using that round
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/telemetry/round?year=${year}&trackID=${trackID}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Round fetch failed: ${res.status}`);
        return res.json();
      })
      .then((roundData) => {
        setRound(roundData);
        const roundNumber = roundData?.round ?? roundData;
        return fetch(`${process.env.REACT_APP_BACKEND_URL}/api/telemetry/result?round=${roundNumber}&year=${year}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
      })
      .then((res) => {
        if (!res.ok) throw new Error(`Result fetch failed: ${res.status}`);
        return res.json();
      })
      .then((resultData) => {
        setRaceResult(resultData);
      })
      .catch((error) => {
        console.error("Failed to load AI coach data", error);
        setRaceResult([]);
      })
      .finally(() => setRaceResultLoaded(true));
  }, [dropdownStates]);

  // UseEffect to dynamically assign which component should be displayed from the analysistypes -> dependent on the analysis type the user wants
  useEffect(() => {
    // If one hasnt been selected then simpley return nothing
    if (!analysisType) return;

    if (analysisType === "race-analysis") {
      setAnalysisComponent(
        <RaceAnalysis
          raceResult={raceResult}
          setDoAllInputsExist={setDoAllInputsExist}
          promptInputError={promptInputError}
          setPromptInputError={setPromptInputError}
          setChatGPTResponse={setChatGPTResponse}
        />
      );
    } else {
      setAnalysisComponent(
        <LapAnalysis
          analysisType={analysisType}
          setDoAllInputsExist={setDoAllInputsExist}
          promptInputError={promptInputError}
          setPromptInputError={setPromptInputError}
          setChatGPTResponse={setChatGPTResponse}
        />
      );
    }
  }, [analysisType]);

  useEffect(() => {
    if (promptInputError) {
      alert("Please enter a prompt");
    }
  }, [promptInputError]);

  return (
    <div className="ai-coach-container">
      {showSidebar || <SideBar setPage={setPage} />}

      <div className="ai-coach-content">
        <div className="ai-coach-header">Welcome to the AI analysis hub!</div>

        <div className="ai-coach-dropdowns">
          <Dropdowns
            setDropdownStates={setDropdownStates}
            page={page}
            setFigureImage={setFigureImage}
            raceResultLoaded={raceResultLoaded}
            setRaceResultLoaded={setRaceResultLoaded}
          />
        </div>

        <div className="ai-coach-options">
          <ul className="ai-coach-options-list">
            <li
              className={
                analysisType === "race-analysis"
                  ? "analysis-input-active"
                  : "analysis-input"
              }
              onClick={() => {
                if (!raceResultLoaded) return alert("Loading session results — please wait.");
                if (raceResult === undefined || raceResult.length === 0) return alert("Please select a session using the dropdowns");
                setAnalysisType(aiAnalysisTypes[0]);
              }}
            >
              Race Analysis
            </li>
            <li
              className={
                analysisType === "lap-analysis"
                  ? "analysis-input-active"
                  : "analysis-input"
              }
              onClick={() => {
                if (!raceResultLoaded) return alert("Loading session results — please wait.");
                setAnalysisType(aiAnalysisTypes[1]);
              }}
            >
              AI Lap Analysis
            </li>
            <li
              className={
                analysisType === "compare-driver-analysis"
                  ? "analysis-input-active"
                  : "analysis-input"
              }
              onClick={() => {
                if (!raceResultLoaded) return alert("Loading session results — please wait.");
                setAnalysisType(aiAnalysisTypes[2]);
              }}
            >
              AI Driver Comparison Analysis
            </li>
          </ul>

          <div className="analysis-inputs">
            <div className={analysisType}>{analysisComponent}</div>
          </div>
        </div>

        <div
          className={
            doAllInputsExist ? "output-container" : "output-container-hidden"
          }
        >
          {chatGPTResponse ? chatGPTResponse : ""}
        </div>
      </div>
    </div>
  );
};

export default Coach;
